import * as yup from 'yup';
import { OTP_CODE_LENGTH } from '../../../constants/general';
import { OTP_REQUIRED, OTP_INVALID, COMPANY_NAME_INVALID, COMPANY_ADDRESS_INVALID, COMPANY_ADDRESS_LINE_2_INVALID, ZIPCODE_REQUIRED, PHONE_REQUIRED, FIELD_REQUIRED, FIRST_NAME_INVALID, LAST_NAME_INVALID, PHONE_INVALID, COMPANY_ADDRESS_REQUIRED, COMPANY_NAME_REQUIRED, BUSINESS_TYPE_REQUIRED, FIRST_NAME_REQUIRED, LAST_NAME_REQUIRED, } from '../../../constants/field-error-messages';
import { NUMBERS_REGEX_GLOBAL, COMPANY_NAME_REGEX, ADDRESS_REGEX, ZIPCODE_REGEX, PHONE_REGEX, NAME_REGEX, } from '../../../constants/regex';
export var otpValidation = yup.object({
    otpField: yup
        .string()
        .required(OTP_REQUIRED.message)
        .matches(NUMBERS_REGEX_GLOBAL, OTP_INVALID.message)
        .min(OTP_CODE_LENGTH, OTP_INVALID.message),
});
export var companyDetailsValidation = yup.object().shape({
    companyName: yup
        .string()
        .required(COMPANY_NAME_REQUIRED.message)
        .trim()
        .matches(COMPANY_NAME_REGEX, COMPANY_NAME_INVALID.message),
    tradeType: yup.string().required(BUSINESS_TYPE_REQUIRED.message),
    otherBusiness: yup.string().trim(),
    firstName: yup
        .string()
        .required(FIRST_NAME_REQUIRED.message)
        .trim()
        .matches(NAME_REGEX, FIRST_NAME_INVALID.message),
    lastName: yup
        .string()
        .required(LAST_NAME_REQUIRED.message)
        .trim()
        .matches(NAME_REGEX, LAST_NAME_INVALID.message),
    phoneNumber: yup
        .string()
        .required(PHONE_REQUIRED.message)
        .matches(PHONE_REGEX, PHONE_INVALID.message),
    companyAddress: yup
        .string()
        .required(COMPANY_ADDRESS_REQUIRED.message)
        .trim()
        .matches(ADDRESS_REGEX, COMPANY_ADDRESS_INVALID.message),
    companyAddressLine2: yup.string().trim().matches(ADDRESS_REGEX, {
        message: COMPANY_ADDRESS_LINE_2_INVALID.message,
        excludeEmptyString: true,
    }),
    cityState: yup.string().required(FIELD_REQUIRED.message).trim(),
    zipCode: yup
        .string()
        .required(ZIPCODE_REQUIRED.message)
        .matches(ZIPCODE_REGEX, ZIPCODE_REQUIRED.message),
});
